<div class="casinolobbycontainer">
  <div
    class="box"
    *ngFor="let item of gameTypes"
    (click)="goGames(item)"
    [ngStyle]="{ 'background-image': 'url(' + ('/images/casino/trust/' + item.Provider + '/' + item.GameId.replace(':', '') + '.png)') | getAssetsPath }">
    <span>{{ item.GameName }}</span>
  </div>
</div>
